import { render, staticRenderFns } from "./ClinicalTrackingChick.vue?vue&type=template&id=6e4f7382"
import script from "./ClinicalTrackingChick.vue?vue&type=script&lang=js"
export * from "./ClinicalTrackingChick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports